import {APIService} from "../../common/APIService";
import {Todo, TodoEntityType} from "../../dto/Todo";

export class TodoService extends APIService {
  public async browse(): Promise<Todo[]> {
    const json = await this.getJson<{data: object[]}>(`todos`)
    return json.data.map(item => Todo.fromJson(item))
  }

  public async create(text: string, entityType?: TodoEntityType, entityId?: string): Promise<Todo> {
    const json = await this.postJson<{data: object}>(`todos`, {
      text: text,
      entity_type: entityType ?? null,
      entity_id: entityId ?? null,
    })
    return Todo.fromJson(json.data)
  }

  public async update(todoId: string, changes: {text?: string, isDone?: boolean}): Promise<Todo> {
    const json = await this.putJson<{data: object}>(`todos/${todoId}`, {
      ...(changes.text !== undefined ? {text: changes.text} : {}),
      ...(changes.isDone !== undefined ? {is_done: changes.isDone} : {}),
    })
    return Todo.fromJson(json.data)
  }

  public async delete(todoId: string): Promise<void> {
    await this.deleteJson(`todos/${todoId}`)
  }
}
